import { Tooltip, Stack } from '@mui/material'
import { DataTableIconProps } from './_props'

const DataTableIcon = ({ title, icon }: DataTableIconProps) => (
    <Tooltip placement="bottom" title={title}>
        <Stack>{icon}</Stack>
    </Tooltip>
)

export default DataTableIcon
